var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGerm6Orange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.296,
    height: 80.366,
    viewBox: "0 0 71.296 80.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 39.395,
    height: 70.242,
    fill: "#C35322"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "matrix(0.839, 0.545, -0.545, 0.839, 38.257, 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M20.552,66.521a7.542,7.542,0,0,1-3.006-.612,9.306,9.306,0,0,1-4.718-5.124c-2.368-5.4-1.857-11.163-1.132-16.6.4-2.977.866-6.168,1.606-9.332a59.26,59.26,0,0,1,6.285-15.961c1.9-3.317,4.768-8.329,9.535-8.329,1.859,0,4.529.806,6.686,4.646a18.129,18.129,0,0,1,2.365,6.08,19.772,19.772,0,0,1-.891,8.307l-.174.666c-.822,3.186-1.434,6.56-2.025,9.824-1.138,6.275-2.313,12.758-5.054,18.879a14.505,14.505,0,0,1-3.76,5.412,9.068,9.068,0,0,1-5.717,2.147M29.122,12.2c-3.817,0-6.4,4.516-8.112,7.5a57.642,57.642,0,0,0-6.11,15.52c-.725,3.1-1.186,6.239-1.577,9.175-.7,5.21-1.189,10.716,1.008,15.729A7.735,7.735,0,0,0,18.2,64.4a5.915,5.915,0,0,0,2.357.478,7.4,7.4,0,0,0,4.663-1.764,13.005,13.005,0,0,0,3.318-4.826c2.66-5.94,3.817-12.322,4.936-18.5.6-3.3,1.215-6.7,2.053-9.95l.174-.667a18.466,18.466,0,0,0,.859-7.638,16.685,16.685,0,0,0-2.175-5.533C32.61,12.859,30.544,12.2,29.122,12.2",
    transform: "translate(-5.029 -4.788)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M23.283,65.961a4.31,4.31,0,0,1-1.713-.343,6.1,6.1,0,0,1-3.013-3.428c-2.027-4.624-1.548-9.874-.885-14.854.385-2.893.839-5.989,1.548-9.019a56.018,56.018,0,0,1,5.938-15.079c1.935-3.38,4.046-6.679,6.689-6.679h.013c1.426.005,2.71,1.006,3.815,2.973a15.241,15.241,0,0,1,1.985,4.986,16.939,16.939,0,0,1-.824,6.964l-.177.675c-.85,3.3-1.473,6.735-2.076,10.06-1.1,6.079-2.241,12.365-4.821,18.126a11.534,11.534,0,0,1-2.875,4.24,5.687,5.687,0,0,1-3.6,1.378M31.847,18.2c-1.915,0-4.1,3.807-5.267,5.854a54.358,54.358,0,0,0-5.764,14.638c-.693,2.961-1.14,6.009-1.519,8.861-.634,4.751-1.1,9.743.761,13.98a4.589,4.589,0,0,0,2.16,2.58,3.672,3.672,0,0,0,3.614-.786,9.932,9.932,0,0,0,2.433-3.655c2.5-5.579,3.619-11.765,4.7-17.748.608-3.354,1.237-6.821,2.1-10.176l.178-.682a15.732,15.732,0,0,0,.791-6.291,13.844,13.844,0,0,0-1.794-4.439c-.795-1.414-1.6-2.133-2.393-2.136ZM20.018,38.5h0Z",
    transform: "translate(-7.754 -7.509)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M57.344,23.275a.819.819,0,0,1-.7-1.25,17.547,17.547,0,0,1,3.312-3.939,1.422,1.422,0,0,1,.9-.378.82.82,0,0,1,.177,1.616,15.979,15.979,0,0,0-2.994,3.561.819.819,0,0,1-.7.39",
    transform: "translate(-25.632 -8.03)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M42.729,6.961h-.011a.82.82,0,0,1-.808-.831,24.452,24.452,0,0,1,.7-5.506.82.82,0,1,1,1.592.391,22.871,22.871,0,0,0-.657,5.138.82.82,0,0,1-.82.808",
    transform: "translate(-19.004 0)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M20.618,28.7a.82.82,0,0,1-.761-.513l-2.527-6.276a.82.82,0,0,1,1.521-.613l2.527,6.275a.819.819,0,0,1-.76,1.126",
    transform: "translate(-7.832 -9.426)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M14.495,42.77a.817.817,0,0,1-.65-.32,6.689,6.689,0,0,0-2.222-1.855l-.225-.113a4.462,4.462,0,0,1-1.1-.694.82.82,0,1,1,1.112-1.205,3.146,3.146,0,0,0,.716.429l.25.126a8.327,8.327,0,0,1,2.771,2.313.82.82,0,0,1-.649,1.319",
    transform: "translate(-4.549 -17.397)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M8.734,60.751a7.761,7.761,0,0,1-4.969-1.822.82.82,0,0,1,1.062-1.25,6.135,6.135,0,0,0,4.065,1.43.82.82,0,1,1,.045,1.639c-.068,0-.136,0-.2,0",
    transform: "translate(-1.576 -26.066)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M56.655,43.484a.82.82,0,0,1-.31-1.579c2.4-.981,4.829-2.02,7.212-3.089a.82.82,0,0,1,.671,1.5c-2.4,1.076-4.844,2.123-7.264,3.111a.812.812,0,0,1-.309.061",
    transform: "translate(-25.319 -17.569)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M53.66,64.184a.82.82,0,0,1-.02-1.64,23.675,23.675,0,0,0,5.495-.789.819.819,0,1,1,.421,1.584,25.3,25.3,0,0,1-5.875.844Z",
    transform: "translate(-23.961 -27.99)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M6.791,81.1h-.03C4.817,81.027,2.4,80.94.4,79.773a.82.82,0,0,1,.829-1.414c1.635.958,3.735,1.034,5.586,1.1A.82.82,0,0,1,6.791,81.1",
    transform: "translate(0 -35.481)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M51.893,80.045a9.451,9.451,0,0,1-1.97-.206.82.82,0,0,1,.342-1.6,7.965,7.965,0,0,0,4.58-.393.82.82,0,1,1,.611,1.521,9.6,9.6,0,0,1-3.562.682",
    transform: "translate(-22.343 -35.271)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M51.77,11.443a.82.82,0,0,1-.746-1.158,9.628,9.628,0,0,1,3.668-4.169.82.82,0,1,1,.861,1.4,7.964,7.964,0,0,0-3.037,3.45.819.819,0,0,1-.747.482",
    transform: "translate(-23.104 -2.718)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M10.028,103.878a.82.82,0,0,1-.721-1.208,7.209,7.209,0,0,1,2.769-2.825.82.82,0,0,1,.806,1.428,5.551,5.551,0,0,0-2.132,2.174.819.819,0,0,1-.723.431",
    transform: "translate(-4.176 -45.227)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M54.562,95.379h-.023a22.551,22.551,0,0,1-8.516-1.939.82.82,0,1,1,.669-1.5,20.923,20.923,0,0,0,7.892,1.8.82.82,0,0,1-.022,1.639",
    transform: "translate(-20.649 -41.659)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M42.246,111.417a.819.819,0,0,1-.657-.328l-3.245-4.334a.82.82,0,0,1,1.313-.983l3.245,4.334a.82.82,0,0,1-.656,1.311",
    transform: "translate(-17.313 -47.814)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M23.143,119.994a.82.82,0,0,1-.677-.356,4.507,4.507,0,0,1-.6-2.774,23.58,23.58,0,0,1,1.143-6.579.82.82,0,1,1,1.559.506,21.936,21.936,0,0,0-1.062,6.122,3.123,3.123,0,0,0,.313,1.8.82.82,0,0,1-.676,1.283",
    transform: "translate(-9.913 -49.752)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M30.242,73.209h-.273a2.552,2.552,0,0,0-1.159.25c-.193.1-.5.337-.48.6.06.693,1.119.853,1.64.853h.273a2.554,2.554,0,0,0,1.159-.25c.193-.1.5-.337.48-.6-.06-.693-1.119-.853-1.64-.853",
    transform: "translate(-12.845 -33.197)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M35.1,53.209c-1.968,0-1.984,1.705,0,1.705,1.968,0,1.984-1.705,0-1.705",
    transform: "translate(-15.244 -24.128)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M36.031,39.776a2.2,2.2,0,0,1-1.142-.29,2.668,2.668,0,0,1-1.106-2.426c-.056-2.633.911-6.576,3.8-6.644a2.508,2.508,0,0,1,2.306,1.249c.962,1.626.473,4.564-.287,5.874a4.352,4.352,0,0,1-3.259,2.221,3.118,3.118,0,0,1-.315.016m-.609-2.75c.011.56.123.943.3,1.051a.827.827,0,0,0,.457.051,2.754,2.754,0,0,0,2-1.413c.545-.94.893-3.2.293-4.216a.852.852,0,0,0-.857-.445c-1.725.041-2.235,3.431-2.2,4.971",
    transform: "translate(-15.318 -13.792)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M39.673,40.938h-.091c-.351,0-.293.544.056.544h.091c.351,0,.293-.544-.056-.544",
    transform: "translate(-17.842 -18.563)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M39.256,36.6c-.353,0-.307.545.043.545s.307-.545-.043-.545",
    transform: "translate(-17.691 -16.598)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M19.979,52.273c-.347,0-.422.542-.071.542s.422-.542.071-.542",
    transform: "translate(-8.923 -23.703)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M18.273,60.769a.273.273,0,0,0,.009.547.273.273,0,0,0-.009-.547",
    transform: "translate(-8.168 -27.556)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M46.616,15.1a.273.273,0,0,0-.01.547.273.273,0,0,0,.01-.547",
    transform: "translate(-21.016 -6.848)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M52.142,50.6c-.348,0-.414.543-.062.543s.414-.543.062-.543",
    transform: "translate(-23.51 -22.947)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M50.025,63.769h-.091c-.353,0-.331.546.021.546h.091c.353,0,.331-.546-.021-.546",
    transform: "translate(-22.527 -28.916)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M50.939,58.269a.273.273,0,0,0,.009.547.273.273,0,0,0-.009-.547",
    transform: "translate(-22.981 -26.422)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M23.779,107.435a.273.273,0,0,0,0,.547.273.273,0,0,0,0-.547",
    transform: "translate(-10.662 -48.717)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M30.33,107.545v.091a.273.273,0,0,0,.547.008v-.091a.273.273,0,0,0-.547-.008",
    transform: "translate(-13.753 -48.649)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M27.385,86.1h-.091a.828.828,0,0,0-.8.841.837.837,0,0,0,.841.8h.091a.828.828,0,0,0,.8-.841.837.837,0,0,0-.841-.8",
    transform: "translate(-12.014 -39.043)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M35.561,83.435H35.47a.82.82,0,1,0,.024,1.64h.091a.82.82,0,1,0-.024-1.64",
    transform: "translate(-15.717 -37.834)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M27,62.522a.871.871,0,0,0-1.06-.154.834.834,0,0,0-.321,1.114.792.792,0,0,0,.236.26.679.679,0,0,0,.126.114.832.832,0,0,0,1.128-.271A.886.886,0,0,0,27,62.522",
    transform: "translate(-11.572 -28.229)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M45.256,25.111a.828.828,0,0,0-.915.712v.091a.842.842,0,0,0,.713.915.828.828,0,0,0,.914-.713v-.091a.841.841,0,0,0-.712-.914",
    transform: "translate(-20.107 -11.386)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M40.236,64.606c-1.048,0-1.188,1.635-.13,1.635s1.188-1.635.13-1.635",
    transform: "translate(-17.856 -29.296)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M30.167,94.683v.273c0,.348.543.417.543.066v-.273c0-.348-.543-.417-.543-.066",
    transform: "translate(-13.679 -42.829)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M25.544,78.781a.442.442,0,0,0-.6,0c-.249.222.04.618.3.455.251.188.548-.221.3-.452",
    transform: "translate(-11.268 -35.669)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M32.409,81.273c-.351,0-.279.542.069.542s.279-.542-.069-.542",
    transform: "translate(-14.591 -36.853)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M34.409,64.439c-.351,0-.279.542.069.542s.278-.542-.069-.542",
    transform: "translate(-15.498 -29.22)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M29.878,52.1h-.091c-.35,0-.372.547-.019.547h.091c.35,0,.372-.547.019-.547",
    transform: "translate(-13.383 -23.626)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M45.466,55.1c-.349,0-.4.545-.045.545s.4-.545.045-.545",
    transform: "translate(-20.487 -24.987)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M42.607,24.6a.273.273,0,0,0,.006.547.273.273,0,0,0-.006-.547",
    transform: "translate(-19.202 -11.156)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M48.043,38.657,47.5,40.115c-.124.33.408.459.53.133l.547-1.458c.124-.33-.408-.459-.53-.133",
    transform: "translate(-21.529 -17.444)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M32.92,47.7l-1.732-.451a.273.273,0,0,0-.146.526l1.732.451a.274.274,0,0,0,.146-.527",
    transform: "translate(-13.988 -21.422)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M43.744,49.272c-.351,0-.282.543.066.543s.283-.543-.066-.543",
    transform: "translate(-19.731 -22.342)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M31.273,65.433,30.632,66.8c-.15.319.359.52.507.2l.642-1.365c.15-.319-.359-.52-.508-.2",
    transform: "translate(-13.878 -29.598)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M25.864,71.952l-.182.638c-.1.337.419.521.515.182l.182-.638c.1-.337-.419-.521-.515-.182",
    transform: "translate(-11.64 -32.545)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M39.053,77.266l-.365,1c-.119.329.381.55.5.219l.365-1c.119-.328-.38-.55-.5-.219",
    transform: "translate(-17.535 -34.962)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M24.374,90.369c-.046-.347-.592-.316-.545.033l.182,1.366c.046.347.592.316.545-.033l-.182-1.366",
    transform: "translate(-10.804 -40.867)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M29.483,99.341l-.729.455c-.3.186.048.61.343.426l.729-.456c.3-.186-.047-.61-.342-.426",
    transform: "translate(-12.987 -45.026)",
    fill: "#C35322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M35.194,91.662l-.365,1.093c-.111.334.424.45.534.119l.364-1.093c.111-.334-.424-.45-.533-.119",
    transform: "translate(-15.787 -41.475)",
    fill: "#C35322"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerm6Orange);
export default __webpack_public_path__ + "static/media/germ-6-orange.84f50f387629fe6f9eec6f62d412f1bc.svg";
export { ForwardRef as ReactComponent };